import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data);
export const getShiftOverride = (data) => Ajax.post('hr/getShiftOverride',data);
export const deleteShiftOverride = (data) => Ajax.post('hr/deleteShiftOverride',data);
export const shiftOverride = (data) => Ajax.post('hr/shiftOverride',data);